<template>
  <div id="screen" class="ui basic container segment" style="overflow:auto">
    <div class="ui purple segment">
      <h3 style="text-align: center">Vehicle stocklist <button class="ui mini button" @click="exportAll">Export all to CSV</button></h3>
      <div class="ui left aligned basic segment">
        <form id="locationform">
          <div class="field">
            <label>Location:</label>
            <select id="locationselector" v-model="selectedlocation" @change="locationChanged" class="ui dropdown">
              <option value="-1"></option>
              <option value="0">All</option>
              <option v-for="(loc,index) in this.$locations" :key="index" :value="loc.id">{{ loc.companyname }}</option>
            </select>
          </div>
        </form>
        <router-link class="ui primary button" to="createstocklist">Create a stocklist</router-link>
      </div>
      <div id="stocklist" class="ui divided items" style="margin-top:1em">
        <StocklistItem v-for="(sli, index) in stocklists" :key="index" class="item" :sli="sli" @saveRegEvent="(e, id)=>onSaveRegEvent(sli._id, e, id)"/>
      </div>
    </div>
  </div>
</template>

<script>

  import StocklistItem from '@/components/StocklistItem.vue'

  function diff (num1, num2) {
    if (num1 > num2) {
      return num1 - num2
    } else {
      return num2 - num1
    }
  }

  function exportToCsv(filename, rows) {
    var processRow = function (row) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] === null ? '' : row[j].toString();
        if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString();
        }
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0)
            result = '"' + result + '"';
        if (j > 0)
            finalVal += ',';
        finalVal += result;
      }
      return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
    }
  }

  export default {
    components: {
      StocklistItem
    },
    methods: {
      onSaveRegEvent(sliid, e, id) {
        console.log('onSaveRegEvent',sliid, e, id);
        fetch(this.$host+'/editstocklist',{
          method:'POST',
          headers:{'Content-type':'application/json'},
          body:JSON.stringify({sliid:sliid, imageid:e, reg:id}),
          credentials:'include',
          mode: "cors",
          cache: 'no-cache'
        }).then(res=>res.json()).then(res=>{
          console.log(res);
        });
      },
      getLocation() {
        var thiz = this;
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((event) =>{
              var i,a,o,op=-1,od,nd;
              
              for (i=0; i< thiz.$locations.length; i++) {
                if (!(thiz.$locations[i].lat)) {
                  continue;
                }

                if (op === -1) {
                  op = i;
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);

                  od = a*a+o*o;
                }
                else {
                  a = diff(event.coords.latitude, thiz.$locations[i].lat);
                  o = diff(event.coords.longitude, thiz.$locations[i].lon);
                  nd = a*a+o*o;

                  if (nd < od) {
                    od=nd;
                    op = i;
                  }
                }
              }
              thiz.selectedlocation = thiz.$locations[op].id;

            },(e)=>{
              console.log(e);
            },{enableHighAccuracy:true}
          );
        } else {
            alert("Your browser doesn't support Geolocation");
        }
      },
      findLocation(lid) {
        for (var i=0; i<this.$locations.length; i++) {
          if ((this.$locations[i].id+'') === lid+'') {
            return this.$locations[i].companyname;
          }
        }

        return '--';
      },
      exportAll() {
        var a,b,i;
        var rows = [];

        for (i=0; i<this.stocklists.length;i++) {
          for (a=0;a<this.stocklists[i].regs.length; a++) {
            b = [
              this.findLocation(this.stocklists[i].location),
              this.stocklists[i].regs[a].reg,
              ((this.stocklists[i].regs[a].vehicle && this.stocklists[i].regs[a].vehicle.make)?this.stocklists[i].regs[a].vehicle.make:'-vehicle not found-'),
              ((this.stocklists[i].regs[a].vehicle && this.stocklists[i].regs[a].vehicle.model)?this.stocklists[i].regs[a].vehicle.model:''),
              ((this.stocklists[i].regs[a].vehicle && this.stocklists[i].regs[a].vehicle.derivative)?this.stocklists[i].regs[a].vehicle.derivative:'')
            ];
            rows.push(b);
          }
        }

        exportToCsv('stocklist.all.'+Date.now()+'.csv', rows);
      },
      locationChanged() {
        console.log('location changed', this.selectedlocation);
        this.loadStocklists();
      },
      loadStocklists() {
        var l = this.selectedlocation+'';
        if (l === "0") l=null;
        const thiz = this;

        fetch(this.$host+'/stocklist', {
          method:'POST',
          headers:{'Content-type':'application/json'},
          body:JSON.stringify({history:true, location:parseInt(l)}),
          credentials:'include',
          mode: "cors",
        cache: 'no-cache'
        }).then(res=>res.json()).then(res=>{
          if (res.error) {
            console.log('application error #36', res);
          }
          else {
            console.log(res.stocklists);
            var i,j;
            for (i=0; i< res.stocklists.length; i++) {
              if (res.stocklists[i].unrecognised) {
                for (j=0; j<res.stocklists[i].unrecognised.length;j++) {
                  res.stocklists[i].unrecognised[j] = {i:res.stocklists[i].unrecognised[j],p:res.stocklists[i].unrecognised[j]};
                }
              }
            }
            thiz.stocklists = res.stocklists;
          }
        }).catch(err=>{
          console.log('system error #37', err);
        })
      }
    },
    data() {
      return {
        selectedlocation:-1,
        stocklists: []
      };
    },
    mounted() {
      this.getLocation();
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);

    }
  }
</script>
